const State = {
  banned: 'banned',
  ready: 'ready',
  running: 'running',
}

export default State